<button
  class="ui-button"
  [class.ui-button--icon-only]="icon() && !ariaLabel()"
  [attr.data-variant]="variant()"
  [attr.data-size]="size()"
  [attr.aria-label]="ariaLabel() || null"
  [disabled]="disabled()"
  [type]="type()"
  [class.ui-button--full]="fullWidth()"
>
  @if (icon() && iconPosition() === 'start') {
    <span class="ui-button__icon material-symbols-rounded" aria-hidden="true">{{ icon() }}</span>
  }
  <span class="ui-button__label">
    @if (label().trim()) {
      {{ translatedLabel() }}
    } @else if (translatedProjectedLabel()) {
      {{ translatedProjectedLabel() }}
    } @else {
      <ng-content />
    }
  </span>
  @if (icon() && iconPosition() === 'end') {
    <span class="ui-button__icon material-symbols-rounded" aria-hidden="true">{{ icon() }}</span>
  }
  @if (badgeText()) {
    <span class="ui-button__badge">{{ badgeText() }}</span>
  }
</button>
